import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'rsuite/dist/rsuite.min.css';
import './App.css';
import { authService, handleApiTokenError } from './services/api';
import { initWriteQueue } from './services/writeQueue';
import QrScanner from './components/QrScanner/QrScanner';
// import { WinUscStatoProvider } from './components/WinUsciteComp/WinUscStato'; // RIMOSSO IMPORT

// Importiamo i componenti che creeremo
import Header from './components/PagesBase/Header';
import Footer from './components/PagesBase/Footer';
import NavigationMenu from './components/PagesBase/NavigationMenu';
import PWAInstallPrompt from './components/PWAInstallPrompt/PWAInstallPrompt';
import Home from './pages/Home/Home';

// import PrivUscite from './pages/PrivUscite/PrivUscite'; // RIMOSSO IMPORT


import PrivateRoute from './components/PrivateRoute';

// Importa il widget Todo effettivo
import Todo from './components/widgets/Todo';
// import Automezzo from './components/widgets/Automezzo'; // RIMOSSO IMPORT
import Carico from './components/widgets/Carico'; // Aggiornato import
import Collaboratori from './components/widgets/Collaboratori'; // Aggiornato import
import Localita from './components/widgets/Localita'; // Aggiornato import
import Foto from './components/widgets/Foto'; // Aggiornato import
import Chat from './components/widgets/Chat'; // Aggiornato import
import Uscite from './components/widgets/Uscite'; // Aggiornato import
import UscitaDetail from './components/widgets/UscitaDetail'; // NUOVO IMPORT

// IMPORT PER INTERAZIONE MAPPA DA WIDGET
import { LocalitaFeature, Uscita as UscitaData } from './services/api'; // MODIFICATO: Import Uscita as UscitaData
import { MapLocationSet } from './types/mapTypes'; // MODIFICATO: Import da nuovo percorso e nuovo nome interfaccia

interface EnrichedMenuItem {
  id: number;
  nome: string;
  icona: string;
  url: string;
  pageId: string;
}

// Il DatePanelComponent placeholder NON sarà più renderizzato direttamente da App.tsx.
// La sua logica/UI sarà gestita all'interno o da NavigationMenu.tsx.
// const DatePanelComponent: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => { ... };

interface UserData {
  soc_id: number;
  soc_nome: string;
  dip_nome: string;
  dip_id: number;
  user_id: number;
  dip_1_admin: number; // Assumiamo 0 = non admin, 1 = admin
  user_menu: EnrichedMenuItem[];
}

// RIMOSSO visibleWidgets
// interface VisibleWidgetsState {
//   [widgetId: string]: boolean;
// }

const AppContent: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [userData, setUserData] = useState<UserData | null>(null);
  const [showEmergencyTools, setShowEmergencyTools] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLoginDropdown, setShowLoginDropdown] = useState(false);
  const [loginFormData, setLoginFormData] = useState({ username: '', password: '' });
  const [activeWidgetId, setActiveWidgetId] = useState<string | null>(null); // NUOVO STATO per il widget attivo
  const [defaultWidgetSet, setDefaultWidgetSet] = useState(false); // NUOVO STATO per tracciare se il widget di default è stato impostato
  const [showQrScanner, setShowQrScanner] = useState(false);
  const [qrProcessing, setQrProcessing] = useState(false);
  const [qrError, setQrError] = useState<string | null>(null);
  const [isQrSession, setIsQrSession] = useState(false);
  const [qrUscita, setQrUscita] = useState<UscitaData | null>(null);
  
  // STATI PER LA MAPPA CONTROLLATA DAI WIDGET
  const [mapFeaturesToDisplay, setMapFeaturesToDisplay] = useState<LocalitaFeature[] | null>(null);
  const [mapBoundsToFit, setMapBoundsToFit] = useState<MapLocationSet['bounds'] | null>(null);
  const [hideChiuse, setHideChiuse] = useState(false);

  // NUOVO STATO PER I DETTAGLI DELL'USCITA SELEZIONATA PER I WIDGET
  const [selectedUscitaForWidgets, setSelectedUscitaForWidgets] = useState<UscitaData | UscitaData[] | null>(null); // MODIFICATO: Accetta Uscita singola, array di Uscite o null
  
  // NUOVO STATO PER L'USCITA SELEZIONATA PER IL DETTAGLIO
  const [selectedUscitaForDetail, setSelectedUscitaForDetail] = useState<UscitaData | null>(null);
  
  // NUOVO STATO PER IL CONTEGGIO DELLE USCITE
  const [usciteCount, setUsciteCount] = useState<number>(0);

  // REF per l'istanza Leaflet (passata da Home via onMapReady)
  const mapInstanceRef = useRef<any>(null);
  const handleMapReady = useCallback((map: any) => {
    mapInstanceRef.current = map;
  }, []);

  const handleLocalitaClick = useCallback((feature: LocalitaFeature) => {
    const map = mapInstanceRef.current;
    if (!map || !feature.geometry?.coordinates?.[0]?.[0]) return;
    let north = -90, south = 90, east = -180, west = 180, hasCoords = false;
    feature.geometry.coordinates[0][0].forEach((coord: number[]) => {
      const [lon, lat] = coord;
      north = Math.max(north, lat); south = Math.min(south, lat);
      east = Math.max(east, lon); west = Math.min(west, lon);
      hasCoords = true;
    });
    if (!hasCoords) return;
    map.flyToBounds(
      [[south, west], [north, east]],
      { padding: [50, 50], animate: true, duration: 1.5 }
    );
  }, []);

  // Debug useEffect per tracciare i cambi di activeWidgetId
  useEffect(() => {
    console.log('[AppContent] WIDGET ATTIVO CAMBIATO:', activeWidgetId);
  }, [activeWidgetId]);

  // Imposta --real-vh come altezza visibile reale (window.innerHeight),
  // più affidabile di dvh/vh su Chrome iPad vecchi con barre browser native
  useEffect(() => {
    const updateVh = () => {
      document.documentElement.style.setProperty('--real-vh', `${window.innerHeight}px`);
    };
    updateVh();
    window.addEventListener('resize', updateVh);
    return () => window.removeEventListener('resize', updateVh);
  }, []);

  // Avvia la coda locale di scritture pendenti verso FM (orari/km/note uscita) — una sola volta
  useEffect(() => {
    initWriteQueue();
  }, []);

  // Controlla se c'è un utente già loggato
  useEffect(() => {
    const storedUserData = sessionStorage.getItem('userDetails');
    if (storedUserData) {
      try {
        const parsedUserData = JSON.parse(storedUserData) as UserData;
        setUserData(parsedUserData);
      } catch (e) {
        console.error('Errore nel parsing dei dati utente:', e);
      }
    }
  }, []);

  // Handler di tastiera per attivare gli strumenti di diagnostica
  // Sequenza: Shift + Alt + D
  useEffect(() => {
    const keySequence: string[] = [];
    
    const handleKeyDown = (e: KeyboardEvent) => {
      // Salva la sequenza di tasti premuti
      if (e.key) {
        keySequence.push(e.key.toLowerCase());
        
        // Mantieni solo gli ultimi 3 tasti
        if (keySequence.length > 3) {
          keySequence.shift();
        }
        
        // Verifica se la sequenza è Shift + Alt + D
        if (e.shiftKey && e.altKey && e.key.toLowerCase() === 'd') {
          setShowEmergencyTools(prev => !prev);
          console.log('Strumenti di emergenza ' + (!showEmergencyTools ? 'attivati' : 'disattivati'));
        }
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showEmergencyTools]);

  // Funzione per pulire tutti i dati in localStorage e sessionStorage
  const clearAllStoredData = useCallback(() => {
    const confirmClear = window.confirm('⚠️ ATTENZIONE: Questa operazione cancellerà tutti i dati salvati dell\'applicazione e ricaricherà la pagina. Procedere?');
    
    if (confirmClear) {
      try {
        // Pulisci localStorage
        localStorage.removeItem('appState');
        // Pulisci sessionStorage
        sessionStorage.removeItem('appStateBackup');
        sessionStorage.removeItem('userDetails');
        sessionStorage.removeItem('sessionToken'); // Assicurati di pulire anche il token
        
        // Ricarica la pagina
        window.location.reload();
      } catch (error) {
        console.error('Errore durante la pulizia dei dati:', error);
        alert('Si è verificato un errore durante la pulizia dei dati: ' + (error as Error).message);
      }
    }
  }, []);

  // const handleHomeClick = () => {
  //   // Implementare la navigazione alla home
  //   console.log('Torna alla home');
  //   // Qui potresti aggiungere logica per la navigazione
  // };

  const toggleMenu = () => {
    setIsMenuOpen(prevIsMenuOpen => !prevIsMenuOpen);
    // Se chiudiamo il menu principale, assicuriamoci che anche il date panel (se è logica del menu) si chiuda.
  };

  // CALLBACK PER AGGIORNARE LA MAPPA DALLA SELEZIONE DEL WIDGET USCITE
  // const handleWidgetSelectionChange = useCallback((features: LocalitaFeature[] | null, bounds: MapLocationSet['bounds'] | null) => { // MODIFICATO
  //   console.log('[AppContent] Widget selection change:', { numFeatures: features?.length, bounds });
  //   setMapFeaturesToDisplay(features);
  //   setMapBoundsToFit(bounds);
  // }, []);

  // NUOVA CALLBACK PER QUANDO UN'USCITA VIENE SELEZIONATA NEL WIDGET USCITE
  const handleUscitaSelectedForWidgets = useCallback((data: UscitaData | UscitaData[] | null) => {
    console.log('[AppContent] RICEVUTO CAMBIO SELEZIONE - data:', data ? (Array.isArray(data) ? `array di ${data.length} uscite` : `uscita singola ${data.mob_usc_id}`) : 'NULL (reset)');
    setSelectedUscitaForWidgets(data);
    console.log('[AppContent] Dati selezionati per widgets:', data);

    // IMPORTANTE: Se ricevuta selezione null (reset), resetta anche il dettaglio
    if (data === null) {
      console.log('[AppContent] Reset completo - cancello anche selectedUscitaForDetail');
      setSelectedUscitaForDetail(null);
    }

    let featuresToDisplay: LocalitaFeature[] = [];

    if (data) {
      if (Array.isArray(data)) {
        // È un array di uscite (selezione di un giorno)
        featuresToDisplay = data.flatMap(uscita => uscita.localita || []);
      } else {
        // È una singola uscita
        if (data.localita && data.localita.length > 0) {
          featuresToDisplay = data.localita;
        }
      }
    }

    if (featuresToDisplay.length > 0) {
      const bounds = calculateBoundingBoxForApp(featuresToDisplay);
      setMapFeaturesToDisplay(featuresToDisplay);
      setMapBoundsToFit(bounds);
    } else {
      setMapFeaturesToDisplay(null);
      setMapBoundsToFit(null);
    }
  }, []);

  // Funzione helper per calcolare il bounding box (simile a quella in Uscite.tsx, ma centralizzata o importata)
  const calculateBoundingBoxForApp = (features: LocalitaFeature[]): MapLocationSet['bounds'] | null => { // MODIFICATO: Usa MapLocationSet
    if (!features || features.length === 0) return null;
    
    let north = -90, south = 90, east = -180, west = 180;
    let hasValidCoords = false;

    features.forEach(feature => {
      if (feature.geometry && feature.geometry.coordinates && feature.geometry.coordinates[0] && feature.geometry.coordinates[0][0]) {
        feature.geometry.coordinates[0][0].forEach(([lon, lat]) => {
          if (typeof lat === 'number' && typeof lon === 'number') {
            north = Math.max(north, lat);
            south = Math.min(south, lat);
            east = Math.max(east, lon);
            west = Math.min(west, lon);
            hasValidCoords = true;
          }
        });
      }
    });
    return hasValidCoords ? { north, south, east, west } : null;
  };

  // Funzione per mostrare/nascondere i widget
  // const toggleWidgetVisibility = (widgetId: string) => {
  //   setVisibleWidgets(prev => ({
  //     ...prev,
  //     [widgetId]: !prev[widgetId]
  //   }));
  //   console.log(`Toggled visibility for ${widgetId}: ${!visibleWidgets[widgetId]}`);
  // };

  // NUOVA FUNZIONE PER IMPOSTARE IL WIDGET ATTIVO
  const handleSetActiveWidgetId = (widgetId: string | null) => {
    const newActiveId = activeWidgetId === widgetId ? null : widgetId;
    
    // Caso speciale per uscitaDetail: deve aprire il dettaglio dall'uscita selezionata
    if (newActiveId === 'uscitaDetail') {
      handleOpenUscitaDetailFromMenu();
    } else {
      setActiveWidgetId(newActiveId);
      console.log(`Active widget set to: ${newActiveId}`);
    }
  };

  const isUserAdmin = !!userData && userData.dip_1_admin === 1;

  // Imposta 'uscite' come widget attivo di default dopo il login se nessun altro è attivo
  useEffect(() => {
    if (userData && !defaultWidgetSet) {
      setActiveWidgetId('uscite');
      setDefaultWidgetSet(true); // Segna che il widget di default è stato impostato
    }
    if (!userData) {
      setActiveWidgetId(null); // Resetta il widget attivo al logout
      setDefaultWidgetSet(false); // Resetta per il prossimo login
    }
  }, [userData, defaultWidgetSet]); // MODIFICATE LE DIPENDENZE

  // NOTA: Ora utilizziamo la funzione centralizzata handleApiTokenError da api.ts

  const handleLogin = async (username: string, password: string) => {
    setIsLoading(true);
    setErrorMessage(null);
    
    try {
      // Utilizzo il nuovo authService per il login
      const response = await authService.login(username, password);
      
      if (response.error) {
        // Usa la nuova funzione per gestire gli errori di token
        const friendlyError = handleApiTokenError({ message: response.error, response: { status: response.status } });
        setErrorMessage(friendlyError);
      } else {
        console.log("Login effettuato, risposta dal server:", response.data);
        
        // Assicuriamoci che i dati utente abbiano la struttura corretta
        if (response.data && response.data.user_data) {
          console.log("Dati utente ricevuti:", response.data.user_data);
          // Salva i dati utente in stato
          setUserData(response.data.user_data);
          setShowLoginDropdown(false);
          setLoginFormData({ username: '', password: '' });
        } else {
          console.error("Dati utente non validi nella risposta:", response);
          setErrorMessage("Formato dati utente non valido");
        }
      }
    } catch (error) {
      console.error('Errore durante il login:', error);
      // Usa la nuova funzione per gestire e rinominare l'errore
      const friendlyError = handleApiTokenError(error);
      setErrorMessage(friendlyError);
    } finally {
      setIsLoading(false);
    }
  };

  const handleQrScan = async (raw: string) => {
    setQrError(null);
    setQrProcessing(true);

    let recordId: number | null = null;
    try {
      const parsed = JSON.parse(raw);
      const id = parsed?.recordId ?? parsed?.record_id;
      if (typeof id === 'number' && Number.isFinite(id) && id > 0) {
        recordId = id;
      }
    } catch {
      // not JSON or missing recordId
    }

    if (!recordId) {
      setQrError('QR non riconosciuto o recordId mancante');
      setQrProcessing(false);
      return;
    }

    const response = await authService.qrLogin(recordId);
    setQrProcessing(false);

    if (response.error || !response.data?.user_data) {
      setQrError(response.error || 'Errore sconosciuto dal server');
      return;
    }

    const { user_data, uscita } = response.data;

    // All state updates batched by React 18 — defaultWidgetSet=true prevents 'uscite' override
    setUserData(user_data);
    if (uscita) {
      setQrUscita(uscita as UscitaData); // precarica Uscite widget (skipFetch=true, nessun fmToken)
      setIsQrSession(true);
      setActiveWidgetId('uscite');
    } else {
      setActiveWidgetId('uscite');
    }
    setDefaultWidgetSet(true);
    setShowQrScanner(false);
    setShowLoginDropdown(false);
  };

  const handleLogout = async () => {
    // Attendere la chiamata al backend (chiude la sessione FileMaker vera) prima di ricaricare —
    // altrimenti il reload cancella la richiesta di rete prima che parta.
    await authService.logout();
    setUserData(null);
    setIsQrSession(false);
    setQrUscita(null);
    setIsMenuOpen(false);
    // setVisibleWidgets({}); // RIMOSSO: Non più necessario
    setActiveWidgetId(null); // Resetta il widget attivo al logout
    // Ricarica la pagina per resettare lo stato dell'applicazione
    window.location.reload();
      };



  // CALLBACK PER CHIUDERE IL WIDGET USCITA DETAIL
  const handleCloseUscitaDetail = useCallback(() => {
    console.log('[AppContent] PRIMA chiusura - activeWidgetId:', activeWidgetId);
    setSelectedUscitaForDetail(null);
    setActiveWidgetId(null); // Disattiva semplicemente il widget attivo
    console.log('[AppContent] Chiusura widget UscitaDetail - disattivazione widget');
    console.log('[AppContent] DOPO chiusura - nuovo activeWidgetId dovrebbe essere: null');
  }, [activeWidgetId]);

  // NUOVA CALLBACK PER APRIRE IL DETTAGLIO DAL MENU
  const handleOpenUscitaDetailFromMenu = useCallback(() => {
    console.log('[AppContent] Apertura dettaglio dal menu');
    
    // Trova l'uscita selezionata per i widget
    if (selectedUscitaForWidgets && !Array.isArray(selectedUscitaForWidgets)) {
      console.log('[AppContent] Apertura dettaglio dal menu per uscita:', selectedUscitaForWidgets.mob_usc_id);
      setSelectedUscitaForDetail(selectedUscitaForWidgets);
      setActiveWidgetId('uscitaDetail');
    } else {
      console.warn('[AppContent] Nessuna uscita singola selezionata per aprire il dettaglio dal menu');
      // Fallback: se non c'è una selezione valida, torna al widget uscite
      setActiveWidgetId('uscite');
    }
  }, [selectedUscitaForWidgets]);

  // CALLBACK PER AGGIORNARE IL CONTEGGIO DELLE USCITE
  const handleUsciteCountChange = useCallback((count: number) => {
    console.log('[AppContent] Aggiornamento conteggio uscite:', count);
    setUsciteCount(count);
  }, []);

  // DEBUG per il capogruppo selezionato
  const selectedCapogruppoName = Array.isArray(selectedUscitaForWidgets) 
    ? selectedUscitaForDetail?.gruppo_cg_nome || null
    : selectedUscitaForWidgets?.gruppo_cg_nome || selectedUscitaForDetail?.gruppo_cg_nome || null;
  
  console.log('[AppContent] DEBUG - selectedUscitaForWidgets:', selectedUscitaForWidgets);
  console.log('[AppContent] DEBUG - selectedUscitaForDetail:', selectedUscitaForDetail);
  console.log('[AppContent] DEBUG - selectedCapogruppoName per menu:', selectedCapogruppoName);

  // Memoizzato: senza questo, .filter() genera un nuovo array a ogni render di AppContent,
  // e BackgroundMap ricostruisce l'intero layer GeoJSON (pesante con la geometria reale dei
  // poligoni) anche quando i dati non sono cambiati — causa scatti durante pan/zoom.
  const mapFeaturesFiltered = useMemo(() => {
    if (!hideChiuse) return mapFeaturesToDisplay;
    return mapFeaturesToDisplay?.filter(f =>
      !(f.properties.loc_ck_chiusa === 1 || (f.properties.ora_chiusura_min && f.properties.ora_chiusura_min > 0))
    ) ?? null;
  }, [hideChiuse, mapFeaturesToDisplay]);

  return (
    <div className="app">
      <Header
        userName={userData?.dip_nome}
        isLoggedIn={!!userData}
        onLoginClick={() => setShowLoginDropdown(true)}
        onLogout={handleLogout}
        isMenuOpen={isMenuOpen}
        onToggleMenu={toggleMenu}
      />

      {!userData && showLoginDropdown && (
        <div className="login-dropdown">
          {errorMessage && <p className="login-dropdown-error">{errorMessage}</p>}
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              await handleLogin(loginFormData.username, loginFormData.password);
            }}
          >
            <div className="login-dropdown-fields">
              <input
                type="text"
                placeholder="Username"
                value={loginFormData.username}
                onChange={(e) => setLoginFormData(prev => ({ ...prev, username: e.target.value }))}
                autoComplete="username"
                autoCorrect="off"
                autoCapitalize="none"
                disabled={isLoading}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={loginFormData.password}
                onChange={(e) => setLoginFormData(prev => ({ ...prev, password: e.target.value }))}
                autoComplete="current-password"
                disabled={isLoading}
                required
              />
            </div>
            <div className="login-dropdown-actions">
              <button
                type="button"
                className="login-dropdown-qr"
                title="Login con QR code operatore"
                disabled={isLoading}
                onClick={() => { setShowLoginDropdown(false); setQrError(null); setShowQrScanner(true); }}
              >
                <i className="fas fa-qrcode"></i>
              </button>
              <button
                type="button"
                className="login-dropdown-cancel"
                onClick={() => { setShowLoginDropdown(false); setLoginFormData({ username: '', password: '' }); setErrorMessage(null); }}
                disabled={isLoading}
              >
                Annulla
              </button>
              <button type="submit" className="login-dropdown-submit" disabled={isLoading}>
                {isLoading ? '...' : 'Accedi'}
              </button>
            </div>
          </form>
        </div>
      )}

      {showQrScanner && (
        <QrScanner
          onScan={handleQrScan}
          onClose={() => { setShowQrScanner(false); setShowLoginDropdown(true); setQrError(null); }}
          isProcessing={qrProcessing}
          error={qrError}
        />
      )}

      {!!userData && (
        <NavigationMenu
          // onHomeClick={handleHomeClick} // Rimossa
          isLoggedIn={!!userData}
          isMenuOpen={isMenuOpen}
          toggleMenu={toggleMenu}       // Passiamo la funzione toggleMenu aggiornata
          onLogout={handleLogout}
          userName={userData?.dip_nome}
          isUserAdmin={isUserAdmin}
          // visibleWidgets={visibleWidgets} // RIMOSSO
          activeWidgetId={activeWidgetId} // PASSATO activeWidgetId
          onSetActiveWidget={handleSetActiveWidgetId} // PASSATA la nuova funzione
          usciteCount={usciteCount} // PASSATO il conteggio delle uscite
          selectedUscitaCapogruppo={selectedCapogruppoName}
        />
      )}

      {/* Il DatePanelComponent non è più renderizzato qui, ma gestito da NavigationMenu */}
      {/* <DatePanelComponent isOpen={isDatePanelOpen} onClose={toggleDatePanel} /> */}
      
      {showEmergencyTools && (
        <div 
          style={{
            position: 'fixed',
            top: '10px',
            right: '10px',
            zIndex: 9999,
            background: 'rgba(255, 0, 0, 0.8)',
            padding: '10px',
            borderRadius: '5px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)'
          }}
        >
          <button
            onClick={clearAllStoredData}
            style={{
              background: 'black',
              color: 'white',
              padding: '5px 10px',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            🗑️ Pulisci cache e ricarica
          </button>
        </div>
      )}
      
      <main className="main-content">
        <Routes>
          <Route
            path="/"
            element={<Navigate to="/1" />}
          />

          {/* La seguente Route è stata rimossa come parte della pulizia di PrivUscite
          <Route path="/1034" element={
            <PrivateRoute>
              <WinUscStatoProvider>
                <PrivUscite />
              </WinUscStatoProvider>
            </PrivateRoute>
          } />
          */}

          <Route 
            path="/1" 
            element={(
              <div className="homepage-container"> {/* Contenitore per la home e i widget */}
                <Home
                  isLoggedIn={!!userData}
                  isQrSession={isQrSession}
                  openMenu={toggleMenu}
                  mapFeatures={mapFeaturesFiltered}
                  mapBounds={mapBoundsToFit}
                  onMapReady={handleMapReady}
                />
                {/* Contenitore per i Widget */}
                {!!userData && (
                  <div className={`homepage-widgets-container ${isMenuOpen ? 'menu-is-open' : ''}`}> {/* Classe dinamica */}
                    {/* Ordine di rendering dei widget come da menu (esclusa Home ed Esci) */}
                    {/* Uscite è ora sempre renderizzato, la visibilità è gestita da CSS */}
                    <Uscite
                      onClose={() => handleSetActiveWidgetId('uscite')}
                      isAdmin={isUserAdmin}
                      className={activeWidgetId === 'uscite' ? 'widget-active' : 'widget-hidden'}
                      onUscitaSelected={handleUscitaSelectedForWidgets}
                      onUsciteCountChange={handleUsciteCountChange}
                      skipFetch={isQrSession}
                      preloadedUscite={qrUscita ? [qrUscita] : undefined}
                    />
                    <Carico 
                      onClose={() => handleSetActiveWidgetId('carico')} 
                      className={activeWidgetId === 'carico' ? 'widget-active' : 'widget-hidden'} 
                    />
                    <Collaboratori 
                      onClose={() => handleSetActiveWidgetId('collaboratori')} 
                      ragazzi={Array.isArray(selectedUscitaForWidgets) ? null : selectedUscitaForWidgets?.ragazzi}
                      capogruppo={Array.isArray(selectedUscitaForWidgets) ? null : selectedUscitaForWidgets?.capogruppo && selectedUscitaForWidgets.capogruppo.length > 0 ? selectedUscitaForWidgets.capogruppo[0] : null}
                      className={activeWidgetId === 'collaboratori' ? 'widget-active' : 'widget-hidden'} 
                    />
                    <Localita
                      onClose={() => handleSetActiveWidgetId('localita')}
                      localitaFeatures={Array.isArray(selectedUscitaForWidgets)
                        ? selectedUscitaForWidgets.flatMap(u => u.localita || [])
                        : selectedUscitaForWidgets?.localita}
                      className={activeWidgetId === 'localita' ? 'widget-active' : 'widget-hidden'}
                      hideChiuse={hideChiuse}
                      onToggleHideChiuse={() => setHideChiuse(v => !v)}
                      onLocalitaClick={handleLocalitaClick}
                    />
                    <Todo 
                      onClose={() => handleSetActiveWidgetId('todo')} 
                      className={activeWidgetId === 'todo' ? 'widget-active' : 'widget-hidden'} 
                    />
                    <Foto 
                      onClose={() => handleSetActiveWidgetId('foto')} 
                      className={activeWidgetId === 'foto' ? 'widget-active' : 'widget-hidden'} 
                    />
                    <Chat
                      onClose={() => handleSetActiveWidgetId('chat')}
                      className={activeWidgetId === 'chat' ? 'widget-active' : 'widget-hidden'}
                    />
                    {selectedUscitaForDetail && (
                      <UscitaDetail 
                        uscita={selectedUscitaForDetail}
                        onClose={handleCloseUscitaDetail} 
                        className={activeWidgetId === 'uscitaDetail' ? 'widget-active' : 'widget-hidden'} 
                        isAdmin={isUserAdmin}
                      />
                    )}
                  </div>
                )}
              </div>
            )} 
          />

          {/* Altre route verranno aggiunte qui */}
        </Routes>
      </main>
        
      <Footer />
      
      {/* Componente PWA per gestire installazione e stato offline */}
      <PWAInstallPrompt />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
